






















































const PAGE_INDEX: number = 1;
const PAGE_SIZE: number = 20;
const RANK: number = 2;
import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { timeFormat, downloadFile, setMetaData } from "@/utils/index";
import { ticketClient } from "@/api/index";
import { GetWorkerLoanUnpaidDetailReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon, errorMsg } from "@/utils/request";

@Component({
  name: "LoadLeftUnpaidPrincipal",
})
export default class RepayPrincipal extends Vue {
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private isSearchFormActionDone: boolean = false; // 查询loading
  @Provide() private pageIndex: number = PAGE_INDEX;
  @Provide() private pageSize: number = PAGE_SIZE;
  @Provide() private rank: number = RANK;
  @Provide() private searchForm: any = {
    orderId: null, // 借款ID
  };
  @Provide() private columns: Array<Object> = [
    {
      prop: "jsIndex",
      label: "performance.jsIndex",
      width: "80",
      key: "col-1",
    },
    {
      prop: "ticketid",
      label: "工单ID",
      width: "120",
      key: "col-2",
    },
    {
      prop: "orderid",
      label: "ticket.loanID",
      //  width: '',
      key: "col-3",
    },
    {
      prop: "employeeid",
      label: "Dialer.staffID",
      //  width: '',
      key: "col-4",
    },
    {
      prop: "name",
      label: "performance.name",
      //  width: '',
      key: "col-5",
    },
    {
      prop: "leftunpaidprincipal",
      label: "performance.totalLeftUnpaidPrincipal",
      //  width: '',
      key: "col-6",
    },
    {
      prop: "assigntime",
      label: "ticket.assignTime",
      //  width: '',
      key: "col-7",
    },
    {
      prop: "ctime",
      label: "ticket.foundTime",
      //  width: '',
      key: "col-8",
    }
  ];
  @Provide() private resultData: any = [];

  // methods
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getTableList(); // 获取列表数据
  }
  private getParams() {
    const params = {
      ...this.searchForm,
      itemId: Number(this.$route.query.ticketitemid),
      Timerange: this.$route.query.date,
      Userid: Number(this.$route.query.adminuid),
      appname: this.$route.query.appname,
      loantype: Number(this.$route.query.loantype),
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      sort: "",
      rank: this.rank, // 1 顺序，2 倒叙
    };
    return params;
  }
  private getTableList() {
    let request: any = new GetWorkerLoanUnpaidDetailReq();
    const _arg = this.getParams();
    request.setCommonin(setCommon());
    request.setTicketitemid(_arg.itemId); // 工单 id 
    request.setAdminuid(_arg.Userid); // 用户id
    request.setStatsdate(_arg.Timerange); // 用户id
    request.setAppname(_arg.appname); // 项目名称
    request.setLoantype(_arg.loantype); // 首复贷
    ticketClient.getWorkerLoadUnpaidDetail(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          const data: any = response.toObject();
          if(data.listList) {
            this.resultData = data.listList.map((item: any, index: number) => {
              const temp = {
                jsIndex: index + 1,
                assigntime: item.assigntime && timeFormat(item.assigntime),
                ctime: item.ctime && timeFormat(item.ctime),
              };
              return Object.assign({}, item, temp);
            });
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
  private sortChange(val: any) {
  }
  private searchFormAction() {
    // 搜索
    // if(this.testSearchForm()) {
    //   this.isSearchFormActionDone = true;
    //   this.pageIndex = 1;
    //   if(this.isHoured){
    //     this.RangeType = 3;
    //   }else{
    //     this.RangeType = 4;
    //   }
    //   this.getTableList();
    // }
  }
  private exportFormAction() {
    const _arg = this.getParams();
    let request: any = new GetWorkerLoanUnpaidDetailReq();
    request.setCommonin(setCommon());
    request.setTicketitemid(_arg.itemId); // 工单 id 
    request.setAdminuid(_arg.Userid); // 用户id
    request.setStatsdate(_arg.Timerange); // 用户id
    request.setAppname(_arg.appname); // 项目名称
    request.setLoantype(_arg.loantype); // 首复贷
    ticketClient.getWorkerLoadUnpaidDetailExcel(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          const res: any = response.toObject();
          if (res.filechunk) {
            let bStr = atob(res.filechunk),
              n = bStr.length,
              unit8Array = new Uint8Array(n);
            while (n--) {
              unit8Array[n] = bStr.charCodeAt(n);
            }
            const blob = new Blob([unit8Array], {
              type: "application/vnd.ms-excel;charset=utf-8",
            });
            downloadFile(blob, res.filename);
          }
        }
      }
    );
  }
}
